import ReactDOM from 'react-dom/client';
import './index.css';
import LendingApp from 'lending/LendingApp';
import { configureApi } from 'lending/api';
import { fixtureMode } from 'lending/fixtures';
import { setParentOrigin } from 'lending/parent';
import { ILendingInit } from 'lending/types';

/**
 * The merchant's page (public/sdk.js) opens this app in a frame and sends the session token and mode once. The
 * frame answers only that page's origin, and starts once.
 */
let started = false;

const render = () => ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<LendingApp />);

// Dev preview (REACT_APP_LENDING_FIXTURE): start straight away against the in-memory fixtures.
if (fixtureMode()) {
  started = true;
  render();
}

window.addEventListener('message', (event: MessageEvent) => {
  const init = event.data as Partial<ILendingInit> | undefined;
  if (started || !init || typeof init.sessionToken !== 'string' || (init.mode !== 'TEST' && init.mode !== 'PROD')) {
    return;
  }
  started = true;
  setParentOrigin(event.origin);
  configureApi({ sessionToken: init.sessionToken, mode: init.mode });

  render();
});
